import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'
import { History as HistoryPage } from '@/pages/history'

export const historyRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/history',
  component: HistoryPage,
})
